// src/pages/FaqIcon.jsx
//
// Split out of navConfig.jsx: a data file that also defines a component
// breaks Vite's Fast Refresh boundary (react-refresh/only-export-components).

export default function FaqIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M1.5 4.2C1.5 3.04 2.44 2.1 3.6 2.1H10.4C11.56 2.1 12.5 3.04 12.5 4.2V8.1C12.5 9.26 11.56 10.2 10.4 10.2H7.9L5.4 12.3V10.2H3.6C2.44 10.2 1.5 9.26 1.5 8.1V4.2Z"
        stroke="currentColor" strokeWidth="0.5" strokeLinejoin="round"
      />
      <path
        d="M5.8 5.1C5.8 4.44 6.34 3.9 7 3.9C7.66 3.9 8.2 4.44 8.2 5.1C8.2 5.6 7.92 5.93 7.43 6.26C7.05 6.51 6.8 6.78 6.8 7.3"
        stroke="currentColor" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"
      />
      <circle cx="7" cy="8.5" r="0.45" fill="currentColor" />
    </svg>
  );
}
